import { render, staticRenderFns } from "./AddNewLawClientForm.vue?vue&type=template&id=c67c90a0&"
import script from "./AddNewLawClientForm.vue?vue&type=script&lang=js&"
export * from "./AddNewLawClientForm.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLawClientForm.vue?vue&type=style&index=0&id=c67c90a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports